<template>
  <BaseContainer>
    <v-content slot="principal">
      <div class="notfound">
        <v-icon class="notfound__icon">mdi-compass-off-outline</v-icon>

        <h1 class="notfound__title">Página não encontrada</h1>

        <p class="notfound__text">
          O endereço que você abriu não existe ou foi movido.
          Estes são os caminhos que funcionam:
        </p>

        <nav class="notfound__links">
          <a href="/">Página inicial</a>
          <a href="/tablet">Tablet de mesa (autoatendimento)</a>
          <a href="/whatsapp">Falar com um especialista</a>
        </nav>
      </div>

      <Footer />
    </v-content>
  </BaseContainer>
</template>

<script>
  import BaseContainer from '@/components/BaseContainer.vue';
  import Footer from '@/components/Footer.vue';

  export default {
    name: 'NotFound',

    components: {
      BaseContainer,
      Footer,
    },
  };
</script>

<style scoped lang="scss">
  .notfound {
    max-width: 640px;
    margin: 0 auto;
    padding: 96px 24px 48px;
    text-align: center;
    color: var(--text-primary);
  }

  .notfound__icon {
    font-size: 64px;
    margin-bottom: 16px;
  }

  .notfound__title {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .notfound__text {
    font-size: 16px;
    color: var(--text-muted);
    margin-bottom: 32px;
  }

  .notfound__links {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;

    a {
      color: var(--text-primary);
      font-weight: 500;
      text-decoration: none;
      border: 1px solid var(--card-border);
      background: var(--card-bg);
      border-radius: 12px;
      padding: 12px 24px;
      min-width: 280px;

      &:hover {
        border-color: #23cf65;
      }
    }
  }
</style>
